import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Layout from '../Layout';


class ImageTextView extends Component{

  render(){
    return(
      <Layout {...this.props} type="ImageTextView"/>
    )
  }
}

ImageTextView.propTypes = {
  childOf:PropTypes.string,
  values:PropTypes.object,
  cell: PropTypes.array,
  layout:PropTypes.func
};

export default ImageTextView;



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Content/ImageTextView.js